import React from "react";
import UserText from "../Assistant/UserText";
import Assistant from "../Assistant/Assistant";
import { isEmptyOrNull } from "../../../../utils/common-utils";
import { Box } from "@chakra-ui/react";
import { useLocation } from "@remix-run/react";
import SummaryLine from "../../../atoms/BubblesLoader/SummaryLine";
import { LiveStreamingStyles } from "./LiveStreamingStyles";
import { useRoot } from "../../../../context/RootContext";
import { useTutor } from "../../../../context/AiTutorContext";
import pkg from "@inrscr/coschool-ui-components";
export default function LiveStreaming({
  query,
  answer,
  loader,
  showUserQuery = true,
  hideVin = false,
  isConclude = false,
}) {
  const { loaderText } = useTutor()
  const location = useLocation();
  let isPracticeScreen = location?.pathname.includes("/practice");
  let isDoubtScreen = location?.pathname.includes("/doubt");
  const { isPlayground } = useRoot();
  const { TutorAssistant: AITutorAssistant } = pkg;
  return (
    <Box
    //sx={isDoubtScreen && LiveStreamingStyles()?.doubtSubContainer}
    >
      {!isEmptyOrNull(query) && showUserQuery && (
        <Box
          sx={
            isPracticeScreen
              ? LiveStreamingStyles()?.practiceUserContainer
              : isDoubtScreen
                ? LiveStreamingStyles()?.doubtUserContainer
                : LiveStreamingStyles()?.generalUserContainer
          }
        >
          <UserText text={query} />
        </Box>
      )}
      {(!isEmptyOrNull(answer) || loader) && (
        <Box
          sx={
            isPracticeScreen
              ? LiveStreamingStyles()?.practiceAssistantContainer
              : isDoubtScreen
                ? LiveStreamingStyles()?.doubtAssistantContainer
                : isPlayground
                  ? LiveStreamingStyles()?.doubtLiveStreamingPlayground
                  : LiveStreamingStyles()?.generalAssistantContainer
          }
        >
          {isConclude && <SummaryLine />}
          <AITutorAssistant text={answer} loader={loader} hideVin={hideVin} loaderText={loaderText} />
        </Box>
      )}
    </Box>
  );
}
